import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {debounceTime} from 'rxjs/operators';
import {CITY, Mode, Source} from '../../common/const';
import {BaseLayerDeck} from '../../common/layers/baseLayerDeck';
import {MapContextService} from '../../common/map-context.service';
import {LayerService} from '../../common/services/layer.service';
import {MvtService} from '../../common/services/mvt.service';
import {RealTimeContextService} from '../real-time-context.service';

@Component({
    selector: 'app-city',
    styleUrls: ['./city.component.scss'],
    template: ''
})
export class CityComponent implements OnInit, OnDestroy {
    protected source = Source;
    protected mode = Mode;
    protected categories: any;
    selectedMode;
    protected layers: { [layer_id: string]: { layer: BaseLayerDeck, modes: string[] } };
    protected subscription: Subscription;
    protected layersLoaded;
    protected interval;

    constructor(
        protected realTimeContextService: RealTimeContextService,
        protected mapContext: MapContextService,
        protected layerService: LayerService,
        @Inject(CITY) protected city,
        protected mvtService: MvtService
    ) {
    }

    ngOnInit() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.subscription = new Subscription();
        this.subscription.add(
            this.mapContext.mapLoaded.subscribe(() => {
                this.subscription.add(
                    this.realTimeContextService.realTimeLayersContext$.subscribe(
                        ([mode, source, categories]) => this.updateComponentView(mode, source, categories)
                    )
                );
            })
        );
        this.subscription.add(
            this.mapContext.onViewRender.pipe(debounceTime(200)).subscribe(() => this.updateCounters())
        );
    }

    updateComponentView(mode, source, categories) {
        if (this.selectedMode && this.selectedMode.mode !== mode.mode) {
            this.updateLayerView(mode);
        }

        if (!this.selectedMode) {
            this.initLayers(mode);
            this.layersLoaded = true;
        }


        if (this.categories) {
            this.updateLayerFilters(mode);
        }
        this.selectedMode = {...mode};
        this.categories = [...categories];
        this.source = [...source] as any;
    }

    initLayers(mode) {
        const modes = this.city.map(c => c.mode);
        const layers: any[] = this.getLayers()
            .filter(l => l.modes.some(m => modes.includes(m)));

        this.layers = {};
        layers.forEach(l => {
            this.layers[l.id] = {
                layer: this.layerService.addLayer(
                    l.layer,
                    l.modes.includes(mode.mode),
                    l.underLayerId,
                ),
                modes: l.modes
            };
            this.subscription.add(
                this.layers[l.id].layer.onHover.pipe(debounceTime(10)).subscribe((hover) => {
                    this.mapContext.deckInstance.setProps({getCursor: () => hover ? 'pointer' : ''});
                })
            );
        });

    }

    updateLayerView(mode) {
        Object.keys(this.layers).forEach(id => {
            const l = this.layers[id];
            if (l.modes.includes(mode.mode) && !l.layer.visible) {
                this.layerService.showLayer(id);
            }
            if (!l.modes.includes(mode.mode) && l.layer.visible) {
                this.layerService.hideLayer(id);
            }
        });

        clearInterval(this.interval);
    }

    updateSources() {
    }


    updateCounters() {
        let updated = false;
        Object.keys(this.layers).forEach(id => {
            const l = this.layers[id];
            if (l.modes.includes(this.selectedMode.mode) && l.layer.visible) {
                updated = true;
                l.layer.updateCounters();
            }
        });
        if (updated) {
            const city = this.city.find(c => c.mode === this.selectedMode.mode);
            this.realTimeContextService.cityVariables.next(city);
        }
    }

    updateLayerFilters(mode) {
        Object.keys(this.layers).forEach(id => {
            const l = this.layers[id];
            if (l.modes.includes(mode.mode) && l.layer.visible) {
                this.layerService.getLayer(id).updateFilters(this.city);
            }
        });
    }

    getLayers() {
        return [];
    }

    getAllowUpdateLayersIds() {
        return [];
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }

        clearInterval(this.interval);
    }

}



// WEBPACK FOOTER //
// ./src/app/real-time/city/city.component.ts